import { render, staticRenderFns } from "./Ext.vue?vue&type=template&id=3d3070fd&scoped=true"
import script from "./Ext.vue?vue&type=script&lang=ts"
export * from "./Ext.vue?vue&type=script&lang=ts"
import style0 from "./Ext.vue?vue&type=style&index=0&id=3d3070fd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3070fd",
  null
  
)

export default component.exports